export default __webpack_public_path__ + "static/media/deactivated-icon.85979335.svg";